import Analyse from "@/utils/analyse";
import {
  APICode,
  FILE_MAX_SIZE,
  FOTOR_MINITOOL_AI_ACTION_FIGURE_TASKLIST,
  I18nLangMap,
  IMAGE_MAX_SLIDER,
  IMAGE_MIN_SLIDER,
  LocalStorageKey,
  LOOP_INTERVAL,
  MAX_LOOP_QUANTITY,
  PageType,
  SCENE_ID,
  TaskStatus,
  TYPE_LIMIT_ACCEPT,
} from "@/constants";
import { create } from "zustand";
import { faceDetect, getLabelList, getTask } from "@/api";
import {
  createFigureTask,
  getEffectList,
  getEffectTasks,
  getUploadUrl,
  uploadS3File,
} from "@/api/effect";
import { t } from "i18next";
import {
  ActionOneParam,
  ActionVoidParam,
  APISignResult,
  FotorResult,
  ICreateFigureTaskParams,
  TEffectClassify,
  TEffectTask,
  TEffectTemplate,
  TEffectTemplateForm,
  TResource,
  TServerDeTectFaceData,
  TTask,
} from "@/types";
import {
  checkType,
  getI18nLang,
  heic2jpeg,
  imageLoader,
  isHeic,
  isTiff,
  isWebp,
  miniZipImg,
  presetTS,
  selectFile,
  sleep,
  tiff2png,
  urlToFile,
  webp2jpeg,
  zipFile,
} from "@/utils";
import TestArr from "./test.json";
import {
  checkResourceFace,
  signResource,
  uploadResource,
} from "@/utils/commonFn";
import { toast } from "react-toastify";
import useUserStore from "./useUserStore";
import EventHub from "@/utils/event";
import { GlobalEvent } from "@/constants/event";
import NewTagManage from "@/utils/newTagManage";
import i18n from "@/locales";

export enum EffectLeftPageType {
  List = "list",
  Detail = "detail",
}

/**
 *  所有流程的进度，包括人脸识别，上传图片 生成进度
 */
interface EffectProgress {
  faceDetection: number;
  upload: number;
  task: number;
  download: number;
}

export type ActionStates = {
  importFileLoading: boolean;
  generating: boolean;
  /**@description 加载状态 */
  effectLoading: boolean;
  task?: TEffectTask;
  fileOptions: {
    /** 原图 */
    originFile?: File;
    /** 压缩至2048的图 */
    uploadFile?: TResource;
    /** 用于检测人脸的图 */
    faceFile?: TResource & { faces?: TServerDeTectFaceData[] };
    blobUrl?: string;
    width?: number;
    height?: number;
    uploadUrl?: string;
    key?: string;
    faceUploadUrl?: string;
  };
  progress: EffectProgress;
  initQuery: {
    classifyid?: string;
    url?: string;
    styleid?: string;
  };
  /** lable 列表 对象 */
  labelListObj: {
    arr: Array<TEffectClassify>;
    loading: boolean;
  };
  /**特效请求情况 */
  effectListLoading: boolean;
  /**特效列表 */
  effectList: TEffectTemplate[];
  currentEffect: TEffectTemplate | null;
  /**
   * @name 存儲特效模板的表單
   */
  effectFormMap: Record<string, TEffectTemplateForm>;
  /** 当前右侧的页面类型 */
  pageType: PageType;
  leftPageType: EffectLeftPageType;
  taskList: TEffectTask[];
  globalLoading: boolean;
  /**当前选中的各类信息 */
  selectObj: {
    lable: { name: string; id: string };
    style: { name: string; id: string };
  };
  /**是否打开自定义面板 */
  customPanel: { visible: boolean; target?: TEffectTemplate };

  errorCode: string;
  errorDesc: string;
  errorMsg: string;
  /**自定义模板各种信息录入 */
  collectionCusInfo: {
    name: string;
    preset: string;
    profession: string;
  };

  guidShow: boolean;
};
type ActionGetters = {
  getters: {
    disabledGenerate: boolean;
  };
};

type ActionMutations = {
  setEffectList: (effectList: TEffectTemplate[]) => void;
  setCurrentEffect: (currentEffect: TEffectTemplate | null) => void;
  setEffectFormMap: (effectId: string, effectForm: TEffectTemplateForm) => void;
  setPageType: (pageType: PageType) => void;
  setLeftPageType: (leftPageType: EffectLeftPageType) => void;
  setTaskList: (taskList: TEffectTask[]) => void;
  addTaskList: (task: TEffectTask) => void;
  setFaceDetectionProgress: (progress: number) => void;
  setUploadProgress: (progress: number) => void;
  setTaskProgress: (progress: number) => void;
  setDownloadProgress: (progress: number) => void;
  /** label和style选择器
   @param type 1 lable 2style
   */
  setChooseInfo: (type: 1 | 2, obj: { id: string; name: string }) => void;
  /**打开或关闭自定义面板 */
  setCustomPanel: (visible: boolean, obj?: TEffectTemplate) => void;
  setCommonError: (code: string) => void;
  setGenerating: (generating: boolean) => void;
  setTask: (task?: TEffectTask) => void;

  preApplyPresetTemp: ActionVoidParam<void>;
  afterApplyPresetTemp: () => Promise<void>;
  setInitQuery: (query: Record<string, string>) => void;
  /** 更新自定义录入内容 */
  setCollectionCusInfo: (obj: ActionStates["collectionCusInfo"]) => void;
  setGuidTipShow: (visible: boolean) => void;
  setImportFileLoading: (loading: boolean) => void;
  clearData: () => void;
};

type ActionActions = {
  getEffectList: (initId?: string) => Promise<void>;
  /**获取lableList */
  getLableList: () => Promise<void>;
  uploadFile(file: File, fn: ActionOneParam<number>): Promise<APISignResult>;
  fetchTask: () => Promise<TEffectTask>;
  loopTask: () => Promise<void>;
  submitTask: (payType: "free" | "credits", position?: string) => void;
  selectImage(position: string, file?: File, autoRun?: boolean): Promise<void>;
  effectGernerate: (position?: string) => Promise<void>;
  retryGenerate(position?: string): Promise<void>;
  refreshNewTag(): Promise<void>;
  refreshI18n(lang: string): Promise<void>;
  logoutCallback(): void;
};

const initActionsState: ActionStates = {
  effectLoading: false,
  importFileLoading: false,
  guidShow: false,
  collectionCusInfo: {
    name: "",
    preset: "",
    profession: "",
  },
  generating: false,
  errorCode: "",
  errorDesc: "",
  errorMsg: "",
  fileOptions: {
    originFile: undefined,

    faceFile: undefined,
    uploadUrl: undefined,
    key: undefined,
    faceUploadUrl: undefined,
  },
  progress: {
    faceDetection: 0,
    upload: 0,
    task: 0,
    download: 0,
  },
  initQuery: {},
  effectList: [],
  effectListLoading: false,
  currentEffect: null,
  pageType: PageType.Ready,
  leftPageType: EffectLeftPageType.List,
  effectFormMap: {},
  taskList: [],
  globalLoading: false,
  selectObj: {
    style: { name: "", id: "" },
    lable: { name: "", id: "" },
  },
  customPanel: { visible: false },
  labelListObj: {
    loading: true,
    arr: [],
  },
};

type ActionStoreState = ActionStates &
  ActionGetters &
  ActionMutations &
  ActionActions;

const useEffectStore = create<ActionStoreState>((setState, getState) => ({
  ...initActionsState,
  //#region mutations
  clearData: () => {
    setState({
      // currentEffect: null,
      customPanel: { visible: false },
      collectionCusInfo: {
        name: "",
        preset: "",
        profession: "",
      },
      fileOptions: {
        originFile: undefined,
        uploadFile: undefined,
        faceFile: undefined,
        uploadUrl: undefined,
        key: undefined,
        faceUploadUrl: undefined,
      },
      task: undefined,
    });
  },
  setImportFileLoading: (loading: boolean) => {
    setState({ importFileLoading: loading });
  },
  setGuidTipShow: (visible: boolean) => {
    setState({ guidShow: visible });
  },
  setCollectionCusInfo: (obj) => {
    setState({
      collectionCusInfo: {
        ...obj,
      },
    });
  },
  setCustomPanel: (visible, obj) => {
    setState({
      customPanel: Object.assign(
        {
          visible: visible,
        },
        obj ? { target: { ...obj } } : {}
      ),
    });
  },
  setChooseInfo: (type, obj) => {
    switch (type) {
      case 1:
        setState({
          selectObj: {
            ...getState().selectObj,
            lable: {
              ...obj,
            },
          },
        });
        break;
      case 2:
        setState({
          selectObj: {
            ...getState().selectObj,
            style: {
              ...obj,
            },
          },
        });
        break;
    }
  },
  setGenerating: (generating: boolean) => {
    setState({ generating });
  },
  setCommonError: (code: string) => {
    if (code === "102") {
      setState({
        errorCode: code,
        errorDesc: t("error_result_vote_desc"),
        errorMsg: t("error_result_vote_title"),
      });
      return;
    }
    setState({
      errorCode: code,
      errorDesc: t("error_result_common_desc"),
      errorMsg: t("error_result_common_title"),
    });
  },
  setEffectList: (effectList: TEffectTemplate[]) => {
    setState({ effectList });
  },
  setCurrentEffect: (currentEffect: TEffectTemplate | null) => {
    setState({ currentEffect });
  },
  setEffectFormMap: (effectId: string, effectForm: TEffectTemplateForm) => {
    const { effectFormMap } = getState();
    setState({ effectFormMap: { ...effectFormMap, [effectId]: effectForm } });
  },
  setPageType: (pageType: PageType) => {
    setState({ pageType });
  },
  setLeftPageType: (leftPageType: EffectLeftPageType) => {
    setState({ leftPageType });
  },
  setTaskList: (taskList: TEffectTask[]) => {
    setState({ taskList });
  },
  setTask(task) {
    setState({ task });
  },
  setInitQuery(query: Record<string, string>) {
    setState({ initQuery: query });
  },
  addTaskList: (task) => {
    const oldTaskList = getState().taskList;
    const newTaskList = [...oldTaskList];
    const index = oldTaskList.findIndex((item) => item.taskId === task.taskId);
    if (index >= 0) {
      newTaskList[index] = task;
    } else {
      newTaskList.unshift(task);
    }
    localStorage.setItem(
      FOTOR_MINITOOL_AI_ACTION_FIGURE_TASKLIST,
      JSON.stringify(newTaskList)
    );
    setState({ taskList: newTaskList });
  },
  setFaceDetectionProgress: (progress: number) => {
    const { progress: oldProgress } = getState();
    setState({ progress: { ...oldProgress, faceDetection: progress } });
  },
  setUploadProgress: (progress: number) => {
    const { progress: oldProgress } = getState();
    setState({ progress: { ...oldProgress, upload: progress } });
  },
  setTaskProgress: (progress: number) => {
    const { progress: oldProgress } = getState();
    setState({ progress: { ...oldProgress, task: progress } });
  },
  setDownloadProgress: (progress: number) => {
    const { progress: oldProgress } = getState();
    setState({ progress: { ...oldProgress, download: progress } });
  },
  //#endregion

  // #region getters
  getters: {
    get disabledGenerate() {
      const { currentEffect, fileOptions } = getState();
      if (!currentEffect) {
        return true;
      }
      if (!fileOptions.uploadFile) {
        return true;
      }
      return false;
    },
    get progress() {
      const { progress } = getState();
      return (
        progress.faceDetection * 0.1 +
        progress.upload * 0.2 +
        progress.task * 0.5 +
        progress.download * 0.2
      );
    },
  },
  //#endregion

  // #region actions

  async uploadFile(file: File, fn: Function) {
    fn?.(0);
    const uploadUrlResult = await getUploadUrl(file.type);
    fn?.(10);
    let { data } = uploadUrlResult;
    const { uploadUrl, backupUploadUrl } = data;
    await uploadS3File(uploadUrl, file, (progress) => {
      fn(0.8 * progress + 10);
    })
      .catch(() => {
        fn?.(10);
        return uploadS3File(backupUploadUrl, file, (progress) => {
          fn(0.8 * progress + 10);
        });
      })
      .then((res) => {
        fn?.(100);
      });
    return data;
  },
  async submitTask(payType = "free", position) {
    const currentEffect = getState().currentEffect;
    if (!currentEffect) {
      toast.error(t("error_no_effect"));
      return;
    }
    setState({
      globalLoading: true,
    });
    Analyse.getInstance().startGenerate();
    const {
      setFaceDetectionProgress,
      setUploadProgress,
      setTaskProgress,
      setDownloadProgress,
      setGenerating,
      setPageType,
      clearData,
    } = getState();
    setFaceDetectionProgress(0);
    setUploadProgress(0);
    setTaskProgress(0);
    setDownloadProgress(0);
    const errorEndCallBack = (
      error: string,
      pageType: PageType = PageType.Ready,
      errorName = "101"
    ) => {
      setGenerating(false);
      setPageType(pageType);
      if (pageType === PageType.Ready) {
        clearData();
      }
      Analyse.getInstance().startGenerateCallback(false, error);
      Analyse.getInstance().startTaskGererateError(false, error);
      const errorInstance = new Error(t(error));
      errorInstance.name = errorName;

      return Promise.reject(errorInstance);
    };
    setPageType(PageType.Generating);
    // MARK: 人脸检测阶段
    if (currentEffect.faceStrength) {
      // 校验人脸
      const { fileOptions } = getState();
      let faceFile = fileOptions.faceFile;
      if (faceFile) {
        try {
          faceFile = await signResource(faceFile);
          setFaceDetectionProgress(20);
          faceFile = await uploadResource(faceFile, (progress) => {
            setFaceDetectionProgress(20 + 0.6 * progress);
          });
        } catch (error) {
          return errorEndCallBack("error_upload_error", PageType.Create, "");
        }

        const faces = await checkResourceFace(faceFile);
        faceFile.faces = faces;
        setState({
          fileOptions: {
            ...fileOptions,
            faceFile,
          },
        });
        if (currentEffect.faceStrength !== faces.length) {
          if (faces.length === 0) {
            return errorEndCallBack("error_no_face");
          }
          if (currentEffect.faceStrength === 1 && faces.length > 1) {
            return errorEndCallBack("error_many_face");
          }
          return errorEndCallBack("error_face_not_equal");
        }
      }
    }
    let uploadFile = getState().fileOptions.uploadFile;
    if (!uploadFile) {
      return errorEndCallBack("error_no_img", PageType.Create);
    }
    // MARK: 上传阶段
    try {
      uploadFile = await signResource(uploadFile);
    } catch (err) {
      return errorEndCallBack("error_sign_error", PageType.Create, "");
    }

    try {
      uploadFile = await uploadResource(uploadFile, (progress) => {
        setUploadProgress(20 + 0.6 * progress);
      });
    } catch (err) {
      return errorEndCallBack("error_upload_error", PageType.Create, "");
    }
    setState({
      fileOptions: {
        ...getState().fileOptions,
        uploadFile,
      },
    });
    setUploadProgress(100);

    // MARK: 生成阶段 TODO
    const store = getState();
    const { collectionCusInfo } = store;

    const params: ICreateFigureTaskParams = {
      width: uploadFile.width || 0,
      height: uploadFile.height || 0,
      originalImageUrl: uploadFile.url || "",
      templateId: currentEffect.id,
      names: collectionCusInfo.name,
      profession: collectionCusInfo.profession,
      //转移逗号
      preset: presetTS(collectionCusInfo.preset),
      pictureNum: 1,
      method: payType,
      // custom: position === "effect-start",
    };

    const task = await createFigureTask(params);
    if (task.code === APICode.Success) {
      const { data } = task;
      setTaskProgress(20);
      setState({
        task: data[0],
      });
      Analyse.getInstance().generateTaskCallBack(true, "");
      Analyse.getInstance().startGenerateCallback(true, "");
    } else {
      let message = "";
      switch (task.code) {
        case "101":
          message = "error_no_face";
          break;
        case "999":
          message = "error_server";
          break;
        case "510":
          message = "error_no_credits";
          break;
        case "102":
          message = "error_img_violation";
          break;
        case "513":
          message = "error_no_credits";
          break;
        case "515":
          message = "error_no_free";
          break;
        default:
          message = task.msg;
          break;
      }
      Analyse.getInstance().startTaskGererateError(false, message);
      Analyse.getInstance().generateTaskCallBack(false, message);
      return errorEndCallBack(message, PageType.Create);
    }
  },

  loopTask: async () => {
    const { fetchTask, setGenerating, setPageType, setTask, addTaskList } =
      getState();
    try {
      let loopQuantity = 0;
      let task = await fetchTask();
      while (
        loopQuantity < MAX_LOOP_QUANTITY &&
        [TaskStatus.Waiting, TaskStatus.Generating].includes(task.status)
      ) {
        await sleep(LOOP_INTERVAL);
        task = await fetchTask();
        loopQuantity += 1;
      }

      setTask(task);
      setGenerating(false);
      Analyse.getInstance().startTaskGererate();
      if (task.whetherViolations === true) {
        // 埋点（敏感图）
        Analyse.getInstance().generateTaskCallBack(
          false,
          "error_img_violation"
        );
        Analyse.getInstance().startGenerateCallback(
          false,
          "error_img_violation"
        );
        getState().setCommonError("102");
        setState({ pageType: PageType.Failed });
        return;
      }
      getState().setCommonError(task.status + "");
      switch (task.status) {
        case TaskStatus.Success:
          // 埋点（成功）
          Analyse.getInstance().generateTaskCallBack(true, "");
          Analyse.getInstance().startGenerateCallback(true, "");
          setTimeout(() => {
            setPageType(PageType.Result);
          }, 500);
          addTaskList({
            ...task,
            form: {
              ...getState().collectionCusInfo,
            },
          });
          break;
        case TaskStatus.Waiting:
        case TaskStatus.Generating:
          task.status = TaskStatus.FeTimeout;
          setState({ task });
          setPageType(PageType.Failed);
          // 埋点（前端超时）
          Analyse.getInstance().startGenerateCallback(false, "fonted_timeout");
          Analyse.getInstance().generateTaskCallBack(false, "fonted_timeout");
          break;
        case TaskStatus.Timeout:
          // 埋点（后端超时）
          Analyse.getInstance().startGenerateCallback(false, "server_timeout");
          Analyse.getInstance().generateTaskCallBack(false, "server_timeout");
          setPageType(PageType.Failed);
          break;
        case TaskStatus.Failed:
          // 埋点（生成失败）
          Analyse.getInstance().generateTaskCallBack(
            false,
            "task_failed_status:" + task.status
          );
          Analyse.getInstance().startGenerateCallback(
            false,
            "task_failed_status:" + task.status
          );
          setPageType(PageType.Failed);

          break;
        default:
          // 埋点（未知）
          Analyse.getInstance().generateTaskCallBack(
            false,
            "unknown_status:" + task.status
          );
          Analyse.getInstance().startGenerateCallback(
            false,
            "unknown_status:" + task.status
          );
          setPageType(PageType.Failed);
          break;
      }
    } catch (err) {
      console.error(err);
      setState({ generating: false });
      setPageType(PageType.Failed);
      Analyse.getInstance().generateTaskCallBack(false, "task error:" + err);
      Analyse.getInstance().startGenerateCallback(false, "task error:" + err);
    }
  },
  fetchTask: () => {
    const { task } = getState();
    return new Promise((resolve, reject) => {
      getEffectTasks(task!.taskId)
        .then((res) => {
          const { code, data, msg } = res;
          if (code === APICode.Success) {
            resolve(data[0]);
          } else {
            reject(new Error(msg));
          }
        })
        .catch(reject);
    });
  },

  preApplyPresetTemp: () => {
    const query = new URLSearchParams(window.location.search);
    const { setInitQuery } = getState();
    const initQuery: Record<string, string> = {};
    query.forEach((value, key) => {
      initQuery[key] = value;
    });

    // query.forEach((value, key) => {
    //   initQuery[key] = value;
    //   query.delete(key);
    // });
    setInitQuery(initQuery);
    let url = window.location.pathname;
    // if ((query as any).size > 0) {
    //   url += ``;
    // }
    window.history.replaceState(null, "", url);
    // const json = localStorage.getItem(FOTOR_MINITOOL_AI_ACTION_FIGURE_TASKLIST);
    // try {
    //   const taskList = JSON.parse(json || "[]");
    //   setState({
    //     taskList,
    //   });
    // } catch (error) {
    //   console.log(error);
    // }
  },
  afterApplyPresetTemp: async () => {
    const { initQuery } = getState();
    if (Reflect.get(initQuery, "url")) {
      const url = Reflect.get(initQuery, "url");
      const reUrl = `https://cors-any.fotor.com/${url}`;
      urlToFile(reUrl).then((file) => {
        if (file) {
          getState().selectImage("url", file, false);
        }
      });
    } else if (
      Reflect.has(initQuery, "bg_type") &&
      Reflect.has(initQuery, "db_key")
    ) {
      const bgType = Reflect.get(initQuery, "bg_type");
      if (bgType === "featuresdb") {
        const dbKey = Reflect.get(initQuery, "db_key");
        const FTIndexDB = await import(
          /* webpackChunkName: "index_db" */
          "@/db/FTIndexDB"
        );
        const instance = FTIndexDB.default.getInstance();
        // 外链带图通过indexDB传递
        await instance.initDB();
        const keys = dbKey.split(",");
        const files: File[] = [];
        for (const key of keys) {
          // eslint-disable-next-line no-await-in-loop
          const file = (await instance.getCacheFile(key)) as File;
          if (file) {
            files.push(file);
            instance.removeCacheImage(key);
          }
        }
        if (files.length > 0) {
          getState().selectImage("indexdb", files[0], false);
        }
      }
    }

    if (initQuery.styleid) {
      const styleId = initQuery.styleid;
      const effectList = getState().effectList;
      const index = effectList.findIndex((item) => item.id === styleId);
      if (index > -1) {
        const effect = effectList[index];
        getState().setChooseInfo(2, {
          ...(effect as any),
        });
        getState().setCurrentEffect(effect);
        Reflect.deleteProperty(initQuery, "styleid");
        setState({ initQuery: { ...initQuery } });
      }
    }
  },
  async selectImage(position: string, file?: File, autoRun = true) {
    const { setPageType, setImportFileLoading } = getState();
    Analyse.getInstance().clickUpImage(position);
    let img: Array<File> = [];
    if (file) {
      img.push(file);
    } else {
      const file = await selectFile({
        accept: TYPE_LIMIT_ACCEPT,
        mutiple: false,
      });
      if (Array.isArray(file)) {
        img.push(...file);
      } else if ((file as any) instanceof FileList) {
        const fileList = file as FileList;
        for (let i = 0; i < fileList.length; i++) {
          img.push(fileList.item(i) as File);
        }
      } else {
        img.push(file);
      }
    }
    const errorCallback = (error: string) => {
      setPageType(PageType.Ready);
      setImportFileLoading(false);
      toast.error(error);
      Analyse.getInstance().clickUpImageCallback(false, error, position);
    };
    if (img.length > 0) {
      // 判断图片
      for (let i = 0; i < img.length; i++) {
        let file = img[i];
        if (!checkType(file)) {
          errorCallback(t("img_format_error"));
          continue;
        }

        if (isHeic(file)) {
          file = await heic2jpeg(file);
        } else if (isTiff(file)) {
          file = await tiff2png(file);
        } else if (isWebp(file)) {
          file = await webp2jpeg(file);
        }
        if (file.size > FILE_MAX_SIZE) {
          return errorCallback(t("img_size_error"));
        }
        setPageType(PageType.Create);
        setImportFileLoading(true);
        const image = await imageLoader(file);
        const max_slider = Math.max(image.width, image.height);
        if (max_slider > IMAGE_MAX_SLIDER) {
          return errorCallback(t("img_max_slider_error"));
        }
        if (max_slider < IMAGE_MIN_SLIDER) {
          return errorCallback(t("img_min_slider_error"));
        }
        let minFile = await zipFile(file);
        let miniFile = await miniZipImg(minFile.file);
        setState({
          fileOptions: {
            originFile: file,
            width: image.width,
            height: image.height,
            uploadFile: {
              file: minFile.file,
              width: minFile.width,
              height: minFile.height,
              blobUrl: URL.createObjectURL(minFile.file),
            },
            faceFile: {
              file: miniFile.file,
              blobUrl: URL.createObjectURL(miniFile.file),
            },
          },
        });
      }
      Analyse.getInstance().clickUpImageCallback(true, "", position);
      setImportFileLoading(false);
      if (!autoRun) {
        return;
      }
      //选中了风格并且不是自定义风格直接生成,只在外面自动生成
      const { currentEffect, customPanel } = getState();
      if (
        currentEffect &&
        currentEffect.type !== "custom" &&
        !customPanel.visible
      ) {
        return getState().effectGernerate(position);
      }
    }
  },
  getLableList() {
    return getLabelList().then((res) => {
      if (res.code === "000") {
        setState({
          labelListObj: {
            loading: false,
            arr: res.data,
          },
        });

        if (res.data?.length > 0) {
          const store = getState();
          const { initQuery } = store;
          const defaultData = res.data[0];
          if (initQuery?.classifyid) {
            const index = res.data.findIndex(
              (item) => item.id === initQuery.classifyid
            );
            if (index > -1) {
              store.setChooseInfo(1, { ...(res.data[index] as any) });
              Reflect.deleteProperty(initQuery, "classifyId");
              setState({ initQuery: { ...initQuery } });
            } else {
              getState().setChooseInfo(1, {
                id: defaultData.id,
                name: defaultData.title,
              });
            }
          } else {
            getState().setChooseInfo(1, {
              id: defaultData.id,
              name: defaultData.title,
            });
          }
        }
      }
    });
  },

  getEffectList: (id?: string) => {
    const { selectObj } = getState();
    setState({
      effectListLoading: true,
    });
    return getEffectList(id || selectObj?.lable?.id)
      .then((res) => {
        const { code, data } = res;
        if (code === APICode.Success) {
          const newData = data.map((item) => {
            item.__showExpand__ =
              item.expand.filter((ele) => ele.enabled).length > 0;
            return item;
          });
          setState({ effectList: newData });
        }
        getState().refreshNewTag();
        setTimeout(() => {
          getState().refreshI18n(I18nLangMap[i18n.language]);
        }, 100);
      })
      .finally(() => {
        setState({
          effectListLoading: false,
        });
      });
  },
  refreshNewTag() {
    const { effectList } = getState();
    const tags = NewTagManage.getInstance().getTags();
    effectList.forEach((item) => {
      if (item.tag?.includes("new")) {
        item._isNEW__ = tags.includes(item.id) ? false : true;
      }
    });
    setState({ effectList });
    return Promise.resolve();
  },
  // MARK: 再次生成
  async effectGernerate(position = "") {
    const {
      generating,
      setGenerating,
      retryGenerate,
      taskList,
      fileOptions,
      currentEffect,
      setPageType,
    } = getState();

    if (generating) {
      toast(t("generating"));
      return;
    }
    if (!fileOptions.originFile) {
      toast(t("error_no_img"));
      return;
    }
    if (fileOptions.uploadFile && currentEffect) {
      const key = fileOptions.uploadFile.url;
      const task = taskList.find(
        (item) =>
          item.originalImageUrl === key && item.templateId === currentEffect?.id
      );
      if (task) {
        setState({
          task,
        });
        setGenerating(false);
        setPageType(PageType.Result);
        return;
      }
    }

    await retryGenerate(position);
  },
  // MARK: 重试
  async retryGenerate(position = "retry") {
    const { generating, setGenerating, submitTask, loopTask } = getState();
    const creditConsume = 1;
    if (generating) {
      toast(t("generating"));
      return;
    }
    setGenerating(true);
    let payType: "free" | "credits" = "free";
    const {
      refreshFreeCount,
      showLogin,
      showPayment,
      receiveCredits,
      fetchCredits,
      fetchVipStatus,
    } = useUserStore.getState();
    if (!localStorage.getItem(LocalStorageKey.userInfo)) {
      await refreshFreeCount();
      let remainNums = useUserStore.getState().remainNums;
      let count = remainNums;
      if (count <= 0) {
        try {
          await showLogin({
            isSignIn: true,
            options: {
              position: "figure_generate",
            },
            isShowScenses: true,
            otherParam: {
              scenesId: SCENE_ID,
            },
          });
          await receiveCredits();
          const credits = await fetchCredits();
          payType = "credits";
          if (credits < creditConsume) {
            await fetchVipStatus();
            try {
              await showPayment({
                position: "figure_generate",
                otherParam: {
                  scenesId: SCENE_ID,
                },
              });
            } catch (err) {
              console.error(err);
              Analyse.getInstance().clickUpGenerate("no_credits");
              // 埋点（积分不足）
              setGenerating(false);

              return;
            }
          }
        } catch (err) {
          console.error(err);
          Analyse.getInstance().clickUpGenerate("no_login");
          setGenerating(false);

          return;
        }
      }
    } else {
      payType = "credits";
      try {
        const isLogin = await useUserStore.getState().fetchUserInfo();
        if (!isLogin) {
          localStorage.removeItem(LocalStorageKey.userInfo);
          return;
        }
        const credits = await fetchCredits();
        if (credits < creditConsume) {
          await fetchVipStatus();

          try {
            await showPayment({
              position: "figure_generate",
              otherParam: {
                scenesId: SCENE_ID,
              },
            });
          } catch (err) {
            console.error(err);
            Analyse.getInstance().clickUpGenerate("no_credits");
            setGenerating(false);

            return;
          }
        } else {
          payType = "credits";
        }
      } catch (error) {
        console.error(error);
      }
    }
    Analyse.getInstance().clickUpGenerate("start");
    try {
      await submitTask(payType, position);
    } catch (err) {
      console.error(err);
      const pageType = useEffectStore.getState().pageType;
      if (pageType !== PageType.Failed) {
        if (err instanceof Error) {
          const name = err.name;
          if (["101", "102", "513", "515"].includes(name)) {
            toast(t(err.message));
          } else {
            toast(t("error_server"));
          }
        } else {
          toast(t("error_server"));
        }
      }
      setGenerating(false);
      EventHub.getInstance().emit(GlobalEvent.REFRESH_CREDITS);
      return;
    }
    const task = useEffectStore.getState().task;
    if (task) {
      EventHub.getInstance().emit(GlobalEvent.REFRESH_CREDITS);
      await loopTask();
      // showRemoveTip();
      const isLogin = useUserStore.getState().getters.isLogin;
      if (!isLogin) {
        useUserStore.getState().refreshFreeCount();
      }
    }
  },
  logoutCallback() {
    const { generating } = getState();
    if (!generating) {
      getState().clearData();
      setState({
        generating: false,
        pageType: PageType.Ready,
      });
    }
  },
  async refreshI18n(lang: string) {
    const { effectList, labelListObj } = getState();
    const labelList = labelListObj.arr;
    const newEffectList = effectList.map((item) => {
      const newItem = { ...item };
      item.title = getI18nLang(item.i18nAttr, lang);
      return newItem;
    });
    const newLabelList = labelList.map((item) => {
      const newItem = { ...item };
      item.title = getI18nLang(item.i18nAttr, lang);
      return newItem;
    });
    setState({
      effectList: newEffectList,
      labelListObj: {
        ...labelListObj,
        arr: newLabelList,
      },
    });
  },
  // #endregion
}));
Reflect.set(window, "useEffectStore", useEffectStore);

export default useEffectStore;
